



























import { confirmUser } from '@/utils/helpers'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class EmailConfirmation extends Vue {
  isLoading = true;
  isConfirmSuccessful = true;
  async mounted () {
    const token = this.$route.params.token
    if (!token) {
      return
    }
    this.isConfirmSuccessful = await confirmUser(token)
    this.isLoading = false
  }
}
